import React from 'react';
import { connect } from 'react-redux';
import visbook from 'api/visbook';
import { emptyReservations, resetCustomerInfo } from 'store';

class ValidUserCheck extends React.Component {

    componentDidMount() {
        const { booking } = this.props;

        if(booking.emailValidated) {
            visbook.getCurrentUser()
                .catch(r => {
                    if(r.response.status === 401) {
                        this.props.emptyReservations()
                        this.props.resetCustomerInfo()
                    }
                })
        }
    }

    render() {
        return null
    }
}

const mapStateToProps = state => {
    return {
        booking: state.booking
    }
}

const actions = {
    emptyReservations,
    resetCustomerInfo,
}

export default connect(mapStateToProps, actions)(ValidUserCheck);
